import { ComponentName } from "../Property/types"

// For now, the Upload component is the only component that handles its own error state
// so we don't want default validation errors for this one
export const getHideValidationErrorDefaultValue = (uiType: ComponentName): boolean => {
  return uiType === "upload" || uiType === "legacyupload"
}
